import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import SubmitSuccess from "../views/submitSuccess.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/submitSuccess",
    name: "SubmitSuccess",
    component: SubmitSuccess
  }
];

const router = new VueRouter({
  routes
});

export default router;
